"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCompanyBuilding = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12 7 12 3 2 3 2 21 22 21 22 7 12 7ZM6 19 4 19 4 17 6 17 6 19ZM6 15 4 15 4 13 6 13 6 15ZM6 11 4 11 4 9 6 9 6 11ZM6 7 4 7 4 5 6 5 6 7ZM10 19 8 19 8 17 10 17 10 19ZM10 15 8 15 8 13 10 13 10 15ZM10 11 8 11 8 9 10 9 10 11ZM10 7 8 7 8 5 10 5 10 7ZM20 19 12 19 12 17 14 17 14 15 12 15 12 13 14 13 14 11 12 11 12 9 20 9 20 19ZM18 11 16 11 16 13 18 13 18 11ZM18 15 16 15 16 17 18 17 18 15Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconChevronLeft')(IconCompanyBuilding);